import React, { HTMLAttributes } from "react";
import "./SlideMenuButton.scss";

interface IProps extends HTMLAttributes<HTMLButtonElement> {
    open: boolean
}

export function SlideMenuButton({ open, className, ...buttonProps }: IProps) {
    return (
        <button className={`${className} slide-menu-button ${open ? 'close-menu' : 'open-menu'}`} {...buttonProps}>
            <div>
                <span />
                <span />
                <span />
                <span />
            </div>
        </button>
    )
}
